import { createNode, DurationDataType, TemporalValueUnion } from '@glueapp/graph-types';
import { objectToTemporal, fromDuration } from '../../utils/temporal';

export const DurationBetween = createNode({
    id: 'Duration Between',
    name: 'Duration Between',
    description: 'Calculates the Duration between two Date, Time, DateTime, or ZonedDateTime values',
    aiDescription:
        'Takes two temporal values of the same type on the "Start" and "End" ports and outputs the Duration between them on the "Duration" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Start: { kind: 'generic', identifier: 'T', extends: TemporalValueUnion },
        End: { kind: 'generic', identifier: 'T' },
    },
    outPorts: {
        Duration: DurationDataType,
    },
    execute: function (input) {
        const start = objectToTemporal(input.inPorts.Start);
        const end = objectToTemporal(input.inPorts.End);
        const duration = start.until(end);
        return { output: { Duration: fromDuration(duration) } };
    },
});
